import { Menu } from 'lucide-react';
import { Link } from 'react-router';

import { NotificationTray } from '@/components/NotificationTray';
import { Button } from '@/components/ui/button';

/**
 * The employee portal's topbar.
 *
 * Deliberately almost empty. The client portal's topbar carries a persistent
 * "Request a Cleaning" because that is the one thing a customer opens the portal
 * to do; a cleaner opens this to look at today, and today is the page they land
 * on. There is nothing to promote.
 *
 * The bell is phase 11.1's tray — a real one, unlike the prototype's 36×36
 * under-floor control (P24). The shared component keeps the 44px hit area.
 */
export function EmployeeTopbar({ onOpenMenu }: { onOpenMenu: () => void }) {
  return (
    <header className="sticky top-0 z-20 flex items-center gap-2 border-b border-ink-300 bg-white px-3 py-2 sm:px-4">
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden"
        aria-label="Open menu"
        onClick={onOpenMenu}
      >
        <Menu aria-hidden="true" />
      </Button>

      {/* `inline-flex` + `min-h-touch`: the wordmark is a link home, and the
          44×44 floor has no exception for a link that happens to be a logo. It
          was 99×22 until the 375px sweep measured it (P23, P24). */}
      <Link
        to="/employee"
        className="inline-flex min-h-touch items-center text-h3 text-bark-700 lg:hidden"
      >
        Honeycomb
      </Link>

      <div className="ml-auto">
        <NotificationTray basePath="/api/employee" />
      </div>
    </header>
  );
}
